import { AbstractControl } from '@angular/forms';

/**
 * Keep validation active while editing, but defer user-facing feedback until
 * the user leaves the control or a submit flow marks it as touched.
 */
export function shouldShowAstralValidationError(control: AbstractControl | null | undefined): boolean {
  return !!control?.invalid && !!control?.touched;
}
